import React, { useEffect, useMemo } from "react";
import { Box, Button, Container, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import { useState } from "react";
import { TbArrowBackUp } from "react-icons/tb";
import { FaFolder, FaFolderOpen } from "react-icons/fa";
import { MdAdd } from "react-icons/md";
import apiClient from "../api/apiClient";
import { handleErrors } from "../modules/handleErrors";
import { useDispatch, useSelector } from "react-redux";
import { login, updatelogin } from "../redux/authSlice";
import InfiniteScroll from "../components/InfiniteScroll";
import { toast } from "react-toastify";
import { useIndexPageData } from "../contextapi/Indexpagedata";
import LoadingSpinner from "../components/LoadingSpinner";
import BundleListingDetails from "./BundleDetails";
import MockupCard from "../components/MockupCard";
import NotFound from "../components/NotFound";
import { useInfiniteScroll } from "../hooks/useInfiniteScroll";
import AddReviewModal from "../modals/AddReviewModal";
import WarningModal from "../modals/WarningModal";
import { SearchBar } from "../Dashboard-Seller/MyListings/components/SearchBar";
import { useGuardedAsync } from "../hooks/useGuardedAsync";

const MyMockups = () => {
  const { isLoggedIn, userType } = useSelector((state) => state.auth);
  const { profiledata, fetchDataprofile } = useIndexPageData();

  const [mocko_id, setMocko_id] = useState(null);
  const { userid } = useSelector((state) => state.auth);
  const [showBundleListings, setShowBundleListings] = useState(false);
  const [bundleListingsById, setBundleListingsById] = useState(false);
  const [bundleListingsId, setBundleListingsId] = useState(false);
  const [search, setsearch] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [showRemove, setShowRemove] = useState(false);
  const [showAddReviewModal, setShowAddReviewModal] = useState(false);
  const [selectedMockupId, setSelectedMockupId] = useState(null);
  const [existingReview, setExistingReview] = useState(null);
  const [folders, setFolders] = useState([]);
  const [currentFolderId, setCurrentFolderId] = useState(null);
  const [showCreateFolderModal, setShowCreateFolderModal] = useState(false);
  const [showMoveToFolderModal, setShowMoveToFolderModal] = useState(false);
  const [selectedMockupForMove, setSelectedMockupForMove] = useState(null);
  const [selectedFolderIdForMove, setSelectedFolderIdForMove] = useState(null);
  const { loading: movingToFolder, run: runMoveToFolder } = useGuardedAsync();
  const [folderName, setFolderName] = useState("");
  const [foldersLoading, setFoldersLoading] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  // Fetch folders
  const fetchFolders = async () => {
    try {
      setFoldersLoading(true);
      const result = await apiClient.get("/folders/");
      setFoldersLoading(false);
      if (result.ok) {
        setFolders(result.data.results || result.data || []);
      }
    } catch (error) {
      setFoldersLoading(false);
      console.error("Error fetching folders:", error);
    }
  };

  // Create folder
  const createFolder = async () => {
    if (!folderName.trim()) {
      toast.error("Please enter a folder name");
      return;
    }
    try {
      setFoldersLoading(true);
      const result = await apiClient.post("/folders/", {
        name: folderName.trim(),
        // user: userid,
      });
      setFoldersLoading(false);
      if (!result.ok) {
        handleErrors(result.data);
        return;
      }
      toast.success("Folder created successfully");
      setFolderName("");
      setShowCreateFolderModal(false);
      fetchFolders();
    } catch (error) {
      setFoldersLoading(false);
      console.error("Error creating folder:", error);
      toast.error("Failed to create folder");
    }
  };

  const deleteFolder = async (folderId) => {
    try {
      const result = await apiClient.delete(`/folders/${folderId}/`);
      if (!result.ok) {
        handleErrors(result.data);
        return;
      }
      toast.success("Folder deleted successfully");
      setCurrentFolderId(null);
      fetchFolders();
    } catch (error) {
      console.error("Error deleting folder:", error);
      toast.error("Failed to delete folder");
    }
  };

  const handleDeleteFolderClick = () => {
    if (currentFolderId) {
      setShowWarning(true);
    } else {
      toast.error("No folder selected");
    }
  };

  const handleDeleteFolderConfirm = () => {
    setShowWarning(false);
    deleteFolder(currentFolderId);
  };

  const moveMockupToFolder = (mockupId, folderId) => {
    runMoveToFolder(async () => {
      try {
        const result = await apiClient.patch(`/listings/${mockupId}/`, {
          folder: folderId,
        });
        if (!result.ok) {
          handleErrors(result.data);
          return;
        }
        toast.success("Mockup moved to folder successfully");
        setShowMoveToFolderModal(false);
        setSelectedMockupForMove(null);
        setSelectedFolderIdForMove(null);
        refetch();
      } catch (error) {
        console.error("Error moving mockup to folder:", error);
        toast.error("Failed to move mockup to folder");
      }
    });
  };
  const removeMockupFromFolder = async (mockupId) => {
    try {
      const result = await apiClient.patch(`/listings/${mockupId}/`, {
        folder: null,
      });
      if (!result.ok) {
        handleErrors(result.data);
        return;
      }
      toast.success("Mockup removed from folder successfully");
      // Refresh data to remove mockup from current view
      refetch();
    } catch (error) {
      console.error("Error moving mockup to folder:", error);
      toast.error("Failed to move mockup to folder");
    }
  };

  // Fetch function for folder mockups (simple - only mockups, no bundles)
  const fetchFolderMockups = useMemo(() => {
    return async (page) => {
      const params = new URLSearchParams();
      params.append("folder", currentFolderId);

      if (searchQuery) {
        params.append("title", searchQuery);
      }

      const mockupsResult = await apiClient.get(
        `/listings/?page=${page}&page_size=10&${params.toString()}`,
      );

      return {
        ok: mockupsResult?.ok,
        data: {
          results: mockupsResult?.ok ? mockupsResult.data.results || [] : [],
          count: mockupsResult?.data?.count || 0,
        },
      };
    };
  }, [searchQuery, currentFolderId]);

  // Combined fetch function for root level (mockups + bundles, not in any folder)
  const fetchCombinedData = useMemo(() => {
    return async (page) => {
      const params = new URLSearchParams();
      if (searchQuery) {
        params.append("title", searchQuery);
      }

      // Only show mockups not in any folder
      params.append("folder__isnull", "true");

      const [mockupsResult, bundlesResult] = await Promise.all([
        apiClient.get(
          `/listings/?mockup=mockup&page=${page}&page_size=10&${params.toString()}`,
        ),
        apiClient.get(
          `/bundle-listings/?my_bundles=bundle&page=${page}&page_size=10&calledFrom=home&${params.toString()}`,
        ),
      ]);

      const mockups = mockupsResult?.ok ? mockupsResult.data.results || [] : [];
      const bundles = bundlesResult?.data?.results || [];

      // Combine and sort by created_at
      const combined = [...bundles, ...mockups].sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at),
      );

      // Return combined result with count from mockups (since that's the primary source)
      return {
        ok: mockupsResult?.ok || bundlesResult?.ok,
        data: {
          results: combined,
          count: mockupsResult?.data?.count || 0,
        },
      };
    };
  }, [searchQuery]);

  // Use the appropriate fetch function based on whether we're in a folder or not
  const fetchFunction = currentFolderId
    ? fetchFolderMockups
    : fetchCombinedData;

  // Use infinite scroll hook
  const {
    data: records,
    loading: loader,
    hasMore,
    loadMore,
    refetch,
  } = useInfiniteScroll(fetchFunction, [searchQuery, currentFolderId], 10);

  const openDeleteModal = (id) => {
    setMocko_id(id);
    setShowRemove(true);
  };

  const fetchBundleDetail = async () => {
    try {
      const result = await apiClient.get(
        `/bundle-listings/${bundleListingsId}/`,
      );
      if (!result.ok) return;
      setBundleListingsById(result?.data || {});
      setShowBundleListings(true);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (bundleListingsId) {
      fetchBundleDetail();
    }
  }, [bundleListingsId]);

  useEffect(() => {
    fetchFolders();
  }, []);

  const [show, setShow] = useState(false);
  const modalClose = () => setShow(false);

  const modalCloseRemove = () => setShowRemove(false);

  const [isBusinessMan, setIsBusinessMan] = useState(false);

  const handleRadioChange = () => {
    setIsBusinessMan(!isBusinessMan);
  };

  //   const ModalFormRemove = () => {
  //     return (
  //       <Modal  show={showRemove}
  //       onHide={modalCloseRemove}  dialogClassName="alert-modal" centered >

  //         <Modal.Body style={{padding:"40px 30px"  , background:"#F8D4B7" , borderTopRightRadius:"24px" , borderBottomLeftRadius:"24px"}}>
  //              <section className='text-center'>

  //                 <p>Are you sure you want to delete?</p>
  //                 <div>
  //                     <button className='btn grey-btn mb-3 px-5' style={{width:"190px", paddingTop:"8px" , paddingBottom:"8px !important"}} onClick={modalCloseRemove}>I'm Sure</button>
  //                 </div>

  //                     <div>
  //                         <button className='btn bg-white px-5' style={{width:"190px" , border:"2px solid #000"}} onClick={modalCloseRemove}>Cancel</button>
  //                     </div>

  //              </section>
  //         </Modal.Body>

  //       </Modal>
  //     );
  //   }

  const handleRemoveModal = (e) => {
    setShowRemove(true);
  };

  const initModal = (e) => {
    e.preventDefault();

    setShow(true);
  };

  const handleApplySearch = (value) => {
    setSearchQuery(value);
  };

  const handleAddReviewClick = (mockupId) => {
    setSelectedMockupId(mockupId);
    // Find the mockup item to check if user has already reviewed
    const mockupItem = records?.find((item) => item?.id === mockupId);
    if (mockupItem?.reviews && Array.isArray(mockupItem.reviews)) {
      const userReview = mockupItem.reviews.find(
        (review) => review?.user_id === userid || review?.user === userid,
      );
      setExistingReview(userReview || null);
    } else {
      setExistingReview(null);
    }
    setShowAddReviewModal(true);
  };

  const handleReviewAdded = () => {
    // Refresh the data to get updated ratings
    refetch();
    setExistingReview(null);
  };

  const handleCreateFolder = () => {
    setShowCreateFolderModal(true);
  };

  const handleMoveToFolder = (mockupId) => {
    setSelectedMockupForMove(mockupId);
    setSelectedFolderIdForMove(null);
    setShowMoveToFolderModal(true);
  };

  const closeMoveToFolderModal = () => {
    if (movingToFolder) return;
    setShowMoveToFolderModal(false);
    setSelectedMockupForMove(null);
    setSelectedFolderIdForMove(null);
  };

  const handleConfirmMoveToFolder = () => {
    if (selectedMockupForMove == null || selectedFolderIdForMove == null) return;
    moveMockupToFolder(selectedMockupForMove, selectedFolderIdForMove);
  };

  const handleFolderClick = (folderId) => {
    setCurrentFolderId(folderId);
  };

  const handleBackToRoot = () => {
    setCurrentFolderId(null);
  };

  const currentFolder = folders.find((f) => f.id === currentFolderId);

  return (
    <>
      {!showBundleListings ? (
        <>
          <section>
            <div className="container">
              <div className="row">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <div className="d-flex align-items-center gap-1 gap-md:3 ">
                    {currentFolderId && (
                      <div style={{ cursor: "pointer" }}>
                        <TbArrowBackUp
                          onClick={handleBackToRoot}
                          style={{
                            fontSize: "32px",
                            backgroundColor: "rgba(0, 0, 0, 0.1)",
                            cursor: "pointer",
                            pointerEvents: "auto",
                          }}
                          className="back-arrow-new cursor-pointer shadow me-2 rounded-5 p-1 "
                        />
                      </div>
                    )}
                    <h2 className="m-0" style={{ color: "#000000e6" }}>
                      {currentFolderId
                        ? (currentFolder?.name.length > 15
                            ? currentFolder.name.slice(0, 15) + "..."
                            : currentFolder.name) || "Folder"
                        : "My Mockups"}
                    </h2>
                  </div>
                  {currentFolderId && (
                    // <div className="mt-4">
                    <button
                      onClick={() => {
                        handleDeleteFolderClick();
                      }}
                      className="btn btn-sm"
                      style={{
                        backgroundColor: "#C93312",
                        color: "white",
                        border: "none",
                        borderRadius: "8px",
                        padding: "8px 16px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                      }}
                    >
                      Delete Folder
                    </button>
                    // </div>
                  )}
                </div>
                <div className="col-md-5 mb-2 ">
                  <SearchBar
                    search={search}
                    setSearch={setsearch}
                    appliedSearch={searchQuery}
                    onApply={handleApplySearch}
                    placeholder="Search in My mockups"
                  />
                </div>
                <div className="col-md-7 mb-2 d-flex align-items-end justify-content-end gap-2">
                  {!currentFolderId && (
                    <button
                      onClick={handleCreateFolder}
                      className="btn"
                      style={{
                        backgroundColor: "#C93312",
                        color: "white",
                        border: "none",
                        borderRadius: "8px",
                        padding: "10px 20px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                      }}
                    >
                      <MdAdd style={{ marginRight: "8px", fontSize: "20px" }} />
                      Create Folder
                    </button>
                  )}
                </div>
                {/* {userType !== "S" && (
              <div className="col-lg-6 offset-lg-1 ">
                <div
                  className="px-md-5 px-3  py-4 "
                  style={{
                    backgroundColor: "#FAE1CE",
                    borderBottomLeftRadius: "50px",
                    borderBottomRightRadius: "50px",
                  }}
                >
                  <h2 className="fw-bold mb-0" style={{ fontSize: "2.65rem" }}>
                    Become a seller
                  </h2>
                  <h6 className="mb-3" style={{ fontSize: "18px" }}>
                    Start selling your mockups and earn some cash!
                  </h6>
                  <div className="d-flex flex-wrap flex-md-nowrap gap-3 justify-content-lg-end justify-content-center">
                    <button className="btn grey-btn">Read More</button>
                    <button className="btn red-btn" onClick={initModal}>
                      Start Selling
                    </button>
                  </div>
                  <ModalForm
                    handleRadioChange={handleRadioChange}
                    modalClose={modalClose}
                    setShow={setShow}
                    isBusinessMan={isBusinessMan}
                    fetchDataprofile={fetchDataprofile}
                    profiledata={profiledata}
                    show={show}
                  />
                </div>
              </div>
            )} */}
              </div>
            </div>
          </section>
          <section className="py-5 mb-5">
            <div className="container">
              {!currentFolderId && folders.length > 0 && (
                <div className="mb-4">
                  <h5 className="mb-3" style={{ color: "#000000e6" }}>
                    Folders
                  </h5>
                  <div className="row">
                    {folders.map((folder) => (
                      <div
                        key={folder.id}
                        className="col-lg-3 col-md-4 col-12 mb-3"
                      >
                        <div
                          className="card p-3 shadow rounded-tr-lg"
                          style={{
                            cursor: "pointer",
                            transition: "transform 0.2s",
                            border: "2px solid transparent",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.transform = "scale(1.05)";
                            e.currentTarget.style.borderColor = "#C93312";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = "scale(1)";
                            e.currentTarget.style.borderColor = "transparent";
                          }}
                          onClick={() => handleFolderClick(folder.id)}
                        >
                          <div className="d-flex align-items-center gap-3">
                            <FaFolder
                              style={{
                                fontSize: "32px",
                                color: "#C93312",
                              }}
                            />
                            <div>
                              <h6 className="mb-0 fw-bold">
                                {folder.name.length > 20
                                  ? folder.name.slice(0, 20) + "..."
                                  : folder.name}
                              </h6>

                              {/* <small className="text-muted">
                                {folder.mockup_count || 0} mockups
                              </small> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {loader && records?.length === 0 ? (
                <div className="d-flex justify-content-center mt-5">
                  <LoadingSpinner />
                </div>
              ) : records?.length > 0 ? (
                <InfiniteScroll
                  onLoadMore={loadMore}
                  hasMore={hasMore}
                  loading={loader}
                >
                  <div className="row">
                    {records?.map((item, index) => (
                      <MockupCard
                        key={item?.id || index}
                        imageUrl={
                          item?.use_main_file_as_thumbnail
                            ? item?.compressed_file
                            : item?.thumbnails?.[0]?.image
                        }
                        title={item?.title}
                        description={item?.short_description}
                        price={item?.price}
                        seller={item?.user_name}
                        id={item?.id}
                        item={item}
                        col={3}
                        setBundleListingsById={setBundleListingsById}
                        setBundleListingsId={setBundleListingsId}
                        setShowBundleListings={setShowBundleListings}
                        pageName={"myMockups"}
                        onAddReviewClick={handleAddReviewClick}
                        onMoveToFolderClick={handleMoveToFolder}
                        showMoveToFolder={
                          !item?.listings_count && !currentFolderId
                        }
                        showRemoveFromFolder={currentFolderId}
                        onRemoveFromFolderClick={removeMockupFromFolder}
                      />
                    ))}
                  </div>
                </InfiniteScroll>
              ) : (
                <NotFound hasActiveSearch={Boolean(searchQuery?.trim())} />
              )}

              {/* < ModalFormRemove  showRemove={showRemove} modalCloseRemove={modalCloseRemove} mocko_id={mocko_id} fetchFeaturedMockups={fetchFeaturedMockups} /> */}
            </div>
          </section>
          <AddReviewModal
            show={showAddReviewModal}
            onClose={() => {
              setShowAddReviewModal(false);
              setSelectedMockupId(null);
              setExistingReview(null);
            }}
            mockupId={selectedMockupId}
            onReviewAdded={handleReviewAdded}
            existingReview={existingReview}
          />
          <WarningModal
            showModal={showWarning}
            modalClose={() => setShowWarning(false)}
            setConfirmClose={() => handleDeleteFolderConfirm()}
            text="Are you sure you want to continue? All mockups from this folder will be moved back to My Mockups."
          />
          {/* Create Folder Modal */}
          <Modal
            show={showCreateFolderModal}
            onHide={() => {
              setShowCreateFolderModal(false);
              setFolderName("");
            }}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>Create New Folder</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="mb-3">
                <label className="form-label">Folder Name</label>
                <input
                  type="text"
                  className="form-control"
                  value={folderName}
                  onChange={(e) => setFolderName(e.target.value)}
                  placeholder="Enter folder name"
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      createFolder();
                    }
                  }}
                />
              </div>
            </Modal.Body>
            <Modal.Footer>
              <button
                className="btn btn-secondary"
                onClick={() => {
                  setShowCreateFolderModal(false);
                  setFolderName("");
                }}
                disabled={foldersLoading}
              >
                Cancel
              </button>
              <button
                className="btn"
                style={{
                  backgroundColor: "#C93312",
                  color: "white",
                  border: "none",
                }}
                onClick={createFolder}
                disabled={foldersLoading}
              >
                {foldersLoading ? "Creating..." : "Create Folder"}
              </button>
            </Modal.Footer>
          </Modal>

          {/* Move to Folder Modal */}
          <Modal
            show={showMoveToFolderModal}
            onHide={closeMoveToFolderModal}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>Move Mockup to Folder</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {folders.length === 0 ? (
                <p className="text-muted">
                  No folders available. Please create a folder first.
                </p>
              ) : (
                <div className="list-group">
                  {folders.map((folder) => {
                    const isSelected = selectedFolderIdForMove === folder.id;
                    return (
                      <button
                        key={folder.id}
                        type="button"
                        className="list-group-item list-group-item-action d-flex align-items-center gap-3"
                        disabled={movingToFolder}
                        onClick={() => setSelectedFolderIdForMove(folder.id)}
                        style={{
                          cursor: movingToFolder ? "not-allowed" : "pointer",
                          border: isSelected
                            ? "2px solid #C93312"
                            : "1px solid #dee2e6",
                          marginBottom: "8px",
                          borderRadius: "8px",
                          opacity: movingToFolder ? 0.7 : 1,
                          backgroundColor: isSelected ? "#fff5f2" : "white",
                          color: "#000",
                        }}
                      >
                        <FaFolder
                          style={{ fontSize: "24px", color: "#C93312" }}
                        />
                        <div className="flex-grow-1 text-start">
                          <h6 className="mb-0" style={{ color: "#000" }}>
                            {folder.name}
                          </h6>
                        </div>
                      </button>
                    );
                  })}
                </div>
              )}
            </Modal.Body>
            <Modal.Footer>
              <button
                type="button"
                className="btn btn-secondary"
                disabled={movingToFolder}
                onClick={closeMoveToFolderModal}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn"
                disabled={
                  movingToFolder ||
                  folders.length === 0 ||
                  selectedFolderIdForMove == null
                }
                onClick={handleConfirmMoveToFolder}
                style={{
                  backgroundColor: "#C93312",
                  color: "#fff",
                  border: "none",
                }}
              >
                {movingToFolder ? "Moving..." : "Confirm"}
              </button>
            </Modal.Footer>
          </Modal>
        </>
      ) : (
        <BundleListingDetails
          bundleListingsById={bundleListingsById}
          loader={loader}
          setShowBundleListings={setShowBundleListings}
        />
      )}
    </>
  );
};

export default MyMockups;
const ModalFormRemove = ({
  showRemove,
  modalCloseRemove,
  mocko_id,
  fetchFeaturedMockups,
}) => {
  const [Loader, setLoader] = useState(false);
  const handleRegister = async (e) => {
    e.preventDefault();

    try {
      setLoader(true);
      const response = await apiClient.delete(`/sales/${mocko_id}/`);
      setLoader(false);

      if (!response.ok) return handleErrors(response.data);
      fetchFeaturedMockups();
      modalCloseRemove();
      toast.success("Delete successfully");
    } catch (error) {}
  };

  return (
    <Modal
      show={showRemove}
      onHide={modalCloseRemove}
      dialogClassName="alert-modal"
      centered
    >
      <Modal.Body
        style={{
          padding: "40px 30px",
          background: "#F8D4B7",
          borderTopRightRadius: "24px",
          borderBottomLeftRadius: "24px",
        }}
      >
        <section className="text-center">
          <p>Are you sure you want to delete?</p>
          <div>
            <button
              className="btn grey-btn mb-3 px-5"
              style={{
                width: "190px",
                paddingTop: "8px",
                paddingBottom: "8px !important",
              }}
              onClick={handleRegister}
            >
              I'm Sure
            </button>
          </div>

          <div>
            <button
              className="btn bg-white px-5"
              style={{ width: "190px", border: "2px solid #000" }}
              onClick={modalCloseRemove}
            >
              Cancel
            </button>
          </div>
        </section>
      </Modal.Body>
    </Modal>
  );
};

const ModalForm = ({
  handleRadioChange,
  show,
  setShow,
  modalClose,
  fetchDataprofile,
  profiledata,
}) => {
  const navigater = useNavigate();
  const dispatch = useDispatch();
  const { userid } = useSelector((state) => state.auth);
  const [Loader, setLoader] = useState(false);

  const [defaultCard, setDefaultCard] = useState(0);
  const [loader, setloader] = useState(false);
  const [loaderdata, setloaderdata] = useState(false);
  const [contectid, setcontectid] = useState(false);
  const [timeoutmanges, settimeoutmanges] = useState(2000);

  // Sample data for card details
  const getCurrentURLParameters = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const params = {};
    for (const [key, value] of searchParams) {
      params[key] = value;
    }
    return params;
  };
  const { id, user } = getCurrentURLParameters();

  const postuserandid = async () => {
    try {
      // setloader(true)
      const result = await apiClient.get(
        `/stripeaccount/activate_account/?user=${user}&id=${id}`,
        {},
      );
      // setloader(false)

      if (profiledata?.role) {
        dispatch(updatelogin({ userType: profiledata?.role }));
      }

      if (!result.ok) return handleErrors(result.data);
      toast.success("Email sent successfully");
    } catch (error) {
      console.error("Error:", error);
    }
  };

  // const handleRadioChange = (index) => {
  //     setDefaultCard(index);
  //   };

  const fetchconect = async () => {
    setLoader(true);
    const result = await apiClient.get(
      "/StripeAccountViewSet/create_stripe_account/",
    );
    setLoader(false);
    fetchdata();
    if (!result.ok) return handleErrors(result.data);
    settimeoutmanges(99999999979900000);
    window.location.href = result?.data?.account_link;
  };

  const fetchManage = async () => {
    setloader(true);
    const result = await apiClient.get(
      "/StripeAccountViewSet/create_login_link/",
    );
    setloader(false);
    fetchdata();
    if (!result.ok) return toast.error("please try again");

    window.open(result?.data?.account_link, "_blank");
  };

  const fetchdata = async () => {
    setloaderdata(true);
    const result = await apiClient.get("/StripeConnectViewSet/");
    setloaderdata(false);
    setcontectid(result?.data?.connect_id);

    if (!result.ok) return;
  };
  useEffect(() => {
    fetchdata();
  }, []);
  //   const dispatch=useDispatch()

  //   useEffect(()=>{
  //      if(profiledata?.role){
  //        dispatch(updatelogin({userType:profiledata?.role}))
  //      }
  //   },[profiledata?.role])

  useEffect(() => {
    if (id && user && profiledata?.role) {
      postuserandid();
    }
  }, [user, id, profiledata?.role]);
  useEffect(() => {
    if (contectid) {
      setTimeout(() => {
        fetchManage();
      }, timeoutmanges);
    }
  }, [contectid]);

  return (
    <Modal
      show={show}
      onHide={modalClose}
      dialogClassName="modal-width seller-popup position-relative"
      centered
    >
      <Modal.Body
        style={{
          padding: "0px",
          background: "#EFF4EE",
          borderTopRightRadius: "50px",
          borderBottomLeftRadius: "50px",
          position: "relative",
        }}
      >
        <section className="p-2">
          <div className="container">
            <div className="row">
              <div className="col-md-5 ">
                <div className="h-100">
                  <TbArrowBackUp
                    className="position-absolute rounded-5 p-1  bg-white back-arrow"
                    style={{
                      top: "15px",
                      left: "10px",
                      fontSize: "32px",
                      color: "#000",
                      cursor: "pointer",
                    }}
                    onClick={modalClose}
                  />
                  <img
                    src="../assets/images/seller-account.png"
                    alt="Image"
                    className="img-fluid mb-hidden object-fit-cover w-100   h-100"
                    style={{ borderTopRightRadius: "100px" }}
                  />
                </div>
              </div>
              <div className="col-md-7">
                <div className="seller-form  mt-3 mt-xl-5 mb-xl-4 mb-3 pe-md-3">
                  <div className="mb-2">
                    <img
                      src="../assets/images/mockee-icon.png"
                      alt=""
                      className="m-auto"
                      style={{ maxWidth: "200px" }}
                    />
                  </div>
                  <h4 className="text-center fw-bold mb-0">Become a Seller!</h4>
                  <div className="text-center col-md-11 m-auto">
                    <p className=" mb-2 ">
                      To start selling your mockups you need to fill those :
                    </p>
                  </div>

                  <div className="" style={{ margin: "auto" }}>
                    {!loaderdata ? (
                      <Box>
                        <Container>
                          <Typography variant="h4" className="fw-normal  mb-4">
                            Payments
                          </Typography>
                          <Box
                            className="px-4 py-5 mx-3"
                            sx={{
                              backgroundColor: "#F9FBFA",
                              borderTopRightRadius: "50px",
                              borderBottomLeftRadius: "50px",
                            }}
                          >
                            <Typography
                              className="mb-2 mt-3"
                              variant="h5"
                              color="initial"
                            >
                              Connect Your Stripe Account
                            </Typography>
                            <Box className="row align-items-start my-3 ">
                              <Box className="d-flex justify-content-between gap-3  align-items-center col-md-9  p-3  bg-white rounded-4 border-2 shadow ">
                                <img
                                  src="../assets/images/stripe.png"
                                  style={{ width: "50px" }}
                                  alt="Paypal"
                                />
                                <Typography variant="body1" color="initial">
                                  Connect if you want to Pay with your Stripe
                                  Account
                                </Typography>

                                {contectid ? (
                                  <Button
                                    disabled={loader}
                                    variant="contained"
                                    className="grey-btn"
                                    onClick={() => fetchManage()}
                                  >
                                    {"Manage"}
                                  </Button>
                                ) : (
                                  <Button
                                    disabled={Loader}
                                    variant="contained"
                                    className="grey-btn"
                                    onClick={() => fetchconect()}
                                  >
                                    {Loader ? "Connect..." : "Connect"}
                                  </Button>
                                )}
                              </Box>
                            </Box>
                          </Box>
                        </Container>
                      </Box>
                    ) : (
                      <div className="d-flex justify-content-center mt-5">
                        <LoadingSpinner color="#FF3E1F" />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Modal.Body>
    </Modal>
  );
};
